import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  Renderer2,
  ViewChild,
  inject,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Checkbox as PrimeCheckbox, CheckboxModule } from 'primeng/checkbox';
import { BaseControlComponent } from './base-control.component';
import { HelpTextComponent } from './help-text.component';
@Component({
  selector: 'app-checkbox',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    CheckboxModule,
    HelpTextComponent,
  ],
  template: `
    <div
      class="tw-flex tw-items-center tw-px-2"
      [class.tw-opacity-55]="control.disabled"
      [class.tw-pointer-events-none]="control.disabled"
    >
      <p-checkbox
        #primeCheckbox
        [formControl]="control"
        [binary]="true"
        [inputId]="id"
        [ariaRequired]="required"
      />
      <label
        [for]="id"
        class="tw-ml-2 tw-mt-1"
        [class.tw-cursor-pointer]="!control.disabled"
        [class.tw-cursor-not-allowed]="control.disabled"
        [class.tw-text-[var(--sed-black-60-color)]]="control.disabled"
        >{{ label }}
        @if (screenReaderLabelSuffix) {
          <span class="tw-sr-only">{{ screenReaderLabelSuffix }}</span>
        }
        @if (required) {
          <span aria-hidden="true"> *</span>
        }
      </label>
    </div>

    @if (showHelpText) {
      <app-help-text [control]="control" [helpText]="helpText" />
    }
  `,
  styles: ``,
})
export class CheckboxComponent extends BaseControlComponent implements AfterViewInit {
  @Input() screenReaderLabelSuffix?: string;

  @ViewChild('primeCheckbox') primeCheckbox?: PrimeCheckbox;
  private renderer = inject(Renderer2);

  ngAfterViewInit() {
    queueMicrotask(() => this.syncAriaDescribedBy());
    this.dispose.subs = this.control.statusChanges.subscribe(() =>
      queueMicrotask(() => this.syncAriaDescribedBy()),
    );
  }

  private syncAriaDescribedBy() {
    const el = this.primeCheckbox?.inputViewChild?.nativeElement;
    if (!el) {
      return;
    }
    const parts: string[] = [];
    if (this.ariaDescribedBy) {
      parts.push(this.ariaDescribedBy);
    }
    const err = this.describedBy;
    if (err) {
      parts.push(err);
    }
    const attr = parts.length ? parts.join(' ') : null;
    if (attr) {
      this.renderer.setAttribute(el, 'aria-describedby', attr);
    } else {
      this.renderer.removeAttribute(el, 'aria-describedby');
    }
  }
}
